export default "__VITE_ASSET__CMxobEjf__"